<template>
    <app-layout>
        <div>
            <div class="max-w-7xl mx-auto py-10 sm:px-6 lg:px-8">
                <JetNavLink :href="route('dashboard')" :active="route().current('user')" class="mb-5">Back</JetNavLink>
                <import-user-form/>
            </div>
        </div>
    </app-layout>
</template>
<style>
    .modal {
        transition: opacity 0.25s ease;
    }
</style>
<script>
    import AppLayout from '@/Layouts/AppLayout'
    import JetNavLink from '@/Jetstream/NavLink'
    import ImportUserForm from '@/components/ImportUserForm'

    export default {
        components: {
            AppLayout,
            ImportUserForm,
            JetNavLink
        }
    }
    
</script>
